var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullTimeBadge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 99,
    viewBox: "0 0 66 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0C2.23858 0 0 2.23858 0 5V94C0 96.7614 2.23858 99 5 99H61C63.7614 99 66 96.7614 66 94V5C66 2.23858 63.7614 0 61 0H5ZM22.2558 5.37208C21.4081 5.37208 20.7209 6.05927 20.7209 6.90697C20.7209 7.75466 21.4081 8.44185 22.2558 8.44185H42.9768C43.8244 8.44185 44.5116 7.75466 44.5116 6.90697C44.5116 6.05927 43.8244 5.37208 42.9768 5.37208H22.2558Z",
    fill: "#006AC3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9885 54.2094L58.3255 47.4349L51.171 43.731L51.5509 35.6902L43.5101 36.0701L39.7746 28.8837L33 33.2207L26.2255 28.8837L22.5216 36.0382L14.4489 35.6583L14.8288 43.6991L7.67432 47.4346L12.0113 54.2092L7.67432 60.9837L14.8288 64.6876L14.4489 72.7284L22.4897 72.3485L26.2252 79.5349L32.9998 75.1979L39.7743 79.5349L43.4782 72.3804L51.519 72.7603L51.1391 64.7195L58.3255 60.984L53.9885 54.2094Z",
    fill: "#66A6DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2401 64.9114C19.3102 64.388 19.3642 63.8592 19.4559 63.3412C20.1628 59.5368 22.1485 56.5638 25.2998 54.3243C27.4798 56.391 30.0484 57.481 33.0486 57.4755C36.0379 57.4755 38.6012 56.3963 40.8026 54.3135C41.2397 54.6588 41.6984 54.988 42.1192 55.3603C44.7741 57.7184 46.3389 60.6594 46.7652 64.1938C46.7921 64.4312 46.8299 64.6741 46.8623 64.9115V65.7749H19.2344C19.2398 65.4889 19.2398 65.1975 19.2398 64.9115L19.2401 64.9114Z",
    fill: "#D5ECFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7015 38.147C34.2465 38.2549 34.8023 38.325 35.3311 38.4761C38.5688 39.3773 40.9647 42.2426 41.2992 45.5936C41.7633 50.2395 38.353 54.3191 33.6853 54.7023C29.4817 55.053 25.6127 52.0582 24.9004 47.8978C24.1342 43.4514 26.9132 39.3072 31.3217 38.3305C31.6778 38.2496 32.0448 38.2064 32.4063 38.1471H33.7014L33.7015 38.147Z",
    fill: "#D5ECFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullTimeBadge);
export default __webpack_public_path__ + "static/media/fullTimeBadge.3a8a9ca14311a7464f002ce0d9fc387a.svg";
export { ForwardRef as ReactComponent };